import React from 'react';

import InstructionLayout, {
    InstructionSpotlight,
    InstructionStep
} from '../instruction-layout';


const startTerminationItems = [
    {
        id: 'terminate-contract',
        number: 1,
        content: (
            <>
                В строке нужного договора нажмите красную
                кнопку <strong>расторжения</strong>.
            </>
        ),
        area: {
            top: 78.55,
            left: 83.88,
            width: 2.16,
            height: 5.32
        }
    },
    {
        id: 'confirm-termination',
        number: 2,
        content: (
            <>
                В окне <strong>«Расторгнуть?» </strong>
                нажмите <strong>«Да»</strong>.
            </>
        ),
        area: {
            top: 60,
            left: 72.5,
            width: 13.5,
            height: 16.5
        }
    }
];


const terminationStartedItems = [
    {
        id: 'termination-started',
        number: 1,
        content: (
            <>
                После подтверждения платформа показывает
                системное уведомление о расторжении договора.
            </>
        ),
        area: {
            top: 0.3,
            left: 0.21,
            width: 99.79,
            height: 99.7
        }
    }
];


const carrierNotificationItems = [
    {
        id: 'notification-message',
        number: 1,
        content: (
            <>
                Перевозчик получает уведомление о том,
                что договор отправлен на расторжение,
                и видит дальнейшие действия.
            </>
        ),
        area: {
            top: 33.44,
            left: 14.31,
            width: 71.38,
            height: 37.17
        }
    },
    {
        id: 'notification-confirm',
        number: 2,
        content: (
            <>
                Ознакомившись с уведомлением,
                нажмите <strong>«OK»</strong>.
            </>
        ),
        area: {
            top: 77.48,
            left: 31.45,
            width: 36.95,
            height: 9.9
        }
    }
];


const carrierContractsItems = [
    {
        id: 'contracts-section',
        number: 1,
        content: (
            <>
                В разделе <strong>«Заявки» </strong>
                откройте вкладку
                <strong> «Заключение договоров»</strong>.
            </>
        ),
        area: {
            top: 46.39,
            left: 0,
            width: 23.16,
            height: 8.53
        }
    },
    {
        id: 'waiting-status',
        number: 2,
        content: (
            <>
                Найдите договор со статусом
                <strong>
                    {' «Ожидает скан расторжения договора»'}
                </strong>.
            </>
        ),
        area: {
            top: 19,
            left: 54,
            width: 21,
            height: 10
        }
    },
    {
        id: 'attach-contracts',
        number: 3,
        content: (
            <>
                Нажмите
                <strong> «Прикрепить договоры»</strong>.
            </>
        ),
        area: {
            top: 19.92,
            left: 82.52,
            width: 14.98,
            height: 8.53
        }
    }
];


const attachAgreementItems = [
    {
        id: 'download-agreement',
        number: 1,
        content: (
            <>
                Скачайте сформированное платформой
                <strong>
                    {' Соглашение о расторжении договора'}
                </strong>.
            </>
        ),
        area: {
            top: 33.37,
            left: 35.53,
            width: 27.47,
            height: 13.7
        }
    },
    {
        id: 'attach-signed-agreement',
        number: 2,
        content: (
            <>
                Подпишите соглашение и прикрепите
                подписанный файл через
                <strong>
                    {' «Прикрепить Соглашение о расторжении договора»'}
                </strong>.
            </>
        ),
        area: {
            top: 47.07,
            left: 35.42,
            width: 27.7,
            height: 11.15
        }
    },
    {
        id: 'send-to-edo',
        number: 3,
        content: (
            <>
                Для отправки через электронный документооборот
                используйте кнопку
                <strong> «Отправить в ЭДО»</strong>.
            </>
        ),
        area: {
            top: 58.22,
            left: 35.53,
            width: 27.47,
            height: 9.56
        }
    },
    {
        id: 'upload-agreement',
        number: 4,
        content: (
            <>
                После прикрепления документа нажмите
                <strong> «Загрузить»</strong>.
            </>
        ),
        area: {
            top: 81.15,
            left: 45.52,
            width: 8.85,
            height: 6.69
        }
    }
];


const terminationStatusItems = [
    {
        id: 'termination-status',
        number: 1,
        content: (
            <>
                После загрузки подписанного соглашения
                статус меняется на
                <strong> «На расторжении»</strong>.
            </>
        ),
        area: {
            top: 54,
            left: 60.5,
            width: 14,
            height: 16
        }
    }
];


const logistActionItems = [
    {
        id: 'open-documents',
        number: 1,
        content: (
            <>
                Нажмите синюю кнопку, чтобы открыть
                документы по расторжению.
            </>
        ),
        area: {
            top: 76.2,
            left: 80.7,
            width: 2.8,
            height: 7
        }
    },
    {
        id: 'approve-termination',
        number: 2,
        content: (
            <>
                Если документы корректны, используйте
                зелёную кнопку
                <strong> согласования</strong>.
            </>
        ),
        area: {
            top: 76.2,
            left: 83.2,
            width: 2.8,
            height: 7
        }
    },
    {
        id: 'reject-termination',
        number: 3,
        content: (
            <>
                Если расторжение нельзя согласовать,
                используйте красную кнопку
                <strong> отклонения</strong>.
            </>
        ),
        area: {
            top: 76.2,
            left: 85.8,
            width: 2.8,
            height: 7
        }
    }
];


const terminationDocumentsItems = [
    {
        id: 'generated-agreement',
        number: 1,
        content: (
            <>
                При необходимости скачайте сформированное
                системой соглашение о расторжении.
            </>
        ),
        area: {
            top: 33.96,
            left: 35.64,
            width: 28.49,
            height: 12.34
        }
    },
    {
        id: 'original-agreement',
        number: 2,
        content: (
            <>
                Скачайте оригинал подписанного
                перевозчиком соглашения для проверки.
            </>
        ),
        area: {
            top: 46.92,
            left: 35.53,
            width: 28.83,
            height: 13.58
        }
    },
    {
        id: 'documents-archive',
        number: 3,
        content: (
            <>
                Все документы можно скачать одним архивом.
            </>
        ),
        area: {
            top: 71.91,
            left: 34.39,
            width: 31.33,
            height: 9.87
        }
    }
];


export default function ContractTerminationInstruction() {
    return (
        <InstructionLayout title="Расторжение договора">
            <p className="instruction-intro">
                Расторжение договора начинается в кабинете логиста.
                После запуска процесса перевозчик получает соглашение
                о расторжении, подписывает и загружает его, после чего
                логист проверяет документы и принимает решение.
            </p>

            <InstructionStep
                number="1"
                title="Запустите расторжение договора"
            >
                <div className="instruction-copy">
                    <p>
                        В кабинете логиста откройте карточку
                        юридического лица и найдите договор,
                        который необходимо расторгнуть.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/contract-termination/01-start-termination.png"
                    alt="Запуск расторжения договора логистом"
                    items={startTerminationItems}
                />

                <div className="instruction-copy">
                    <p>
                        Сразу после подтверждения платформа показывает
                        системное уведомление. На этом процесс
                        расторжения не заканчивается: дальнейшие
                        действия выполняет перевозчик.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/contract-termination/02-termination-started.png"
                    alt="Системное уведомление после запуска расторжения договора"
                    items={terminationStartedItems}
                />
            </InstructionStep>

            <InstructionStep
                number="2"
                title="Перевозчик получает уведомление"
            >
                <div className="instruction-copy">
                    <p>
                        Перевозчику приходит уведомление о начале
                        расторжения. Платформа предлагает перейти
                        в раздел заключения договоров и прикрепить
                        соглашение о расторжении.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/contract-termination/03-carrier-notification.png"
                    alt="Уведомление перевозчику о расторжении договора"
                    items={carrierNotificationItems}
                />
            </InstructionStep>

            <InstructionStep
                number="3"
                title="Откройте договор на расторжение"
            >
                <div className="instruction-copy">
                    <p>
                        В кабинете перевозчика откройте
                        <strong> «Заявки» → «Заключение договоров» </strong>
                        и найдите нужный договор.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/contract-termination/04-carrier-contracts.png"
                    alt="Договор на расторжение в кабинете перевозчика"
                    items={carrierContractsItems}
                    layout="grid"
                />
            </InstructionStep>

            <InstructionStep
                number="4"
                title="Подпишите и загрузите соглашение"
            >
                <div className="instruction-copy">
                    <p>
                        Платформа заранее формирует соглашение
                        о расторжении. Его необходимо скачать,
                        подписать и прикрепить обратно в систему.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/contract-termination/05-attach-termination-agreement.png"
                    alt="Загрузка соглашения о расторжении договора"
                    items={attachAgreementItems}
                    layout="grid"
                />
            </InstructionStep>

            <InstructionStep
                number="5"
                title="Проверьте изменение статуса"
            >
                <div className="instruction-copy">
                    <p>
                        После загрузки подписанного соглашения
                        договор передаётся логисту на проверку.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/contract-termination/06-termination-status.png"
                    alt="Статус договора на расторжении"
                    items={terminationStatusItems}
                />
            </InstructionStep>

            <InstructionStep
                number="6"
                title="Проверьте документы и примите решение"
            >
                <div className="instruction-copy">
                    <p>
                        В кабинете логиста откройте карточку
                        юридического лица. Для договора в статусе
                        <strong> «На расторжении»</strong> доступны
                        просмотр документов, согласование
                        и отклонение расторжения.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/contract-termination/07-logist-actions.png"
                    alt="Действия логиста по договору на расторжении"
                    items={logistActionItems}
                    layout="grid"
                />

                <div className="instruction-copy">
                    <p>
                        Перед принятием решения проверьте загруженное
                        перевозчиком соглашение.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/contract-termination/08-termination-documents.png"
                    alt="Документы по расторжению договора"
                    items={terminationDocumentsItems}
                    layout="grid"
                />

                <div className="instruction-copy">
                    <p>
                        Если документы корректны, вернитесь к карточке
                        договора и согласуйте расторжение зелёной
                        кнопкой. Если документы необходимо отклонить,
                        используйте красную кнопку. После согласования
                        договор расторгается и отправляется в архив.
                    </p>
                </div>
            </InstructionStep>
        </InstructionLayout>
    );
}
